import Vue from 'vue'
import Router from 'vue-router'
import common from './common/common.js'
import store from './store'

const Login = () => import('./views/login/login.vue')
// const ResetPassword = () => import('./views/login/resetPassword.vue')
const Layer = () => import('./views/layer/layer.vue')
const Home = () => import('./views/home/index.vue')
// const ConfigManage = () => import('./views/configManage/index.vue')
// const RolesManage = () => import('./views/rolesManage/index.vue')
// const PermissionsManage = () => import('./views/permissionsManage/index.vue')
// const Emp  = () => import('./views/emp/index.vue')
const OrderManage  = () => import('./views/orderManage/index.vue')
const RetrievePwd  = () => import('./views/login/resetPassword.vue')
// const CarDealers  = () => import('./views/carDealers/index.vue')
// const PaymentApply  = () => import('./views/paymentApply/index.vue')
const error_401  = () => import('./views/error-page/401.vue')
const error_404  = () => import('./views/error-page/404.vue')
const error_500  = () => import('./views/error-page/500.vue')


const ProductPage  = () => import('./views/productPage/index.vue')
const BasicProduct  = () => import('./views/basicProduct/index.vue')
const UiController  = () => import('./views/uiController/index.vue')
const FirmwareVersion  = () => import('./views/firmware/version.vue')
const FirmwarePlan  = () => import('./views/firmware/plan.vue')
const FirmwareDownload  = () => import('./views/firmware/download.vue')

const AppVersion  = () => import('./views/app/version.vue')
const AppPlan  = () => import('./views/app/plan.vue')
const AppDownload  = () => import('./views/app/download.vue')
const AppDevice  = () => import('./views/app/device.vue')


const SMScost  = () => import('./views/account/SMScost.vue')
const AccountHistory  = () => import('./views/account/history.vue')
const AccountRecharge  = () => import('./views/account/recharge.vue')

const FeedBack  = () => import('./views/feedBack/index.vue')
const Push  = () => import('./views/push/index.vue')
const Setting  = () => import('./views/setting/index.vue')


const ProductManage  = () => import('./views/productManage/index.vue')
const LoginStatistics  = () => import('./views/loginStatistics/index.vue')
const DeviceManage  = () => import('./views/deviceManage/index.vue')
const DeviceLocation  = () => import('./views/deviceLocation/index.vue')
const UserManage  = () => import('./views/userManage/index.vue')

const SceneModel  = () => import('./views/sceneModel/index.vue')
const InstallerManage  = () => import('./views/installerManage/index.vue')
const OnboardingBanner  = () => import('./views/onboardingBanner/index.vue')



//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
  routes:[
   
    {//登录页
      path: '/login',
      name: 'login',
      meta: {
        title: 'Login - 登录',
        hideInMenu: true,
        roles: ['admin', 'dealer','installer']
      },
      component: Login
    },

    {//重置密码
      path: '/mng/dealer/findPassword',
      name: 'retrievePwd',
      component: RetrievePwd,
      meta:{
        roles: ['admin', 'dealer','installer']
      }
    },
    
    {
      path: '/401',
      name: 'error_401',
      component: error_401,
      meta:{
        roles: ['admin', 'dealer','installer']
      }
    },
    {
      path: '/500',
      name: 'error_500',
      component: error_500,
      meta:{
        roles: ['admin', 'dealer','installer']
      }
    },
    {
      path: '*',
      name: 'error_404',
      component: error_404,
      meta:{
        roles: ['admin', 'dealer','installer']
      }
    },
    {
      path: '/',
      component: Layer,
      meta:{
        roles: ['admin', 'dealer','installer']
      },
      children: [
       
        {
          path: '/',
          name: 'home2',
          component: Home,
          meta:{
            roles: ['admin', 'dealer','installer']
          }
        },
        {
          path: '/home',
          name: 'home1',
          component: Home,
          meta:{
            roles: ['admin', 'dealer','installer']
          }
        }
       
      ]
    },
    {
      path: '/con',
      name: 'orderManageF',
      component: Layer,
      meta:{
        roles: ['admin', 'dealer','installer']
      },
      children: [
        {//首页
          path: '/home',
          name: 'home',
          meta: {
            hideInMenu: true,
            title: '首页',
            roles: ['admin', 'dealer','installer']
          },
          component: Home
        },
       {//订单管理
            path: '/orderManage',
            name: 'orderManage',
            component: OrderManage,
            meta:{
              roles: ['admin', 'dealer']
            },
        },
         {//产品页面
          path: '/productPage',
          name: 'productPage',
          component: ProductPage,
          meta:{
            roles: ['admin', 'dealer']
          },
         },
         {//基础型号
          path: '/basicProduct',
          name: 'BasicProduct',
          component: BasicProduct,
          meta:{
            roles: ['admin']
          },
         },
         {//控件
          path: '/uiController',
          name: 'uiController',
          component: UiController,
          meta:{
            roles: ['admin']
          },
         },
       
        {//固件管理
          path: '/firmwareVersion',
          name: 'firmwareVersion',
          component: FirmwareVersion,
          meta:{
            roles: ['admin', 'dealer']
          },
        },
        {//固件计划管理
          path: '/firmwarePlan',
          name: 'firmwarePlan',
          component: FirmwarePlan,
          meta:{
            roles: ['admin', 'dealer']
          },
        },
        {//固件下载历史
          path: '/firmwareDownload',
          name: 'firmwareDownload',
          component: FirmwareDownload,
          meta:{
            roles: ['admin', 'dealer']
          },
        },
        {//app管理
          path: '/appVersion',
          name: 'appVersion',
          component: AppVersion,
          meta:{
            roles: ['admin', 'dealer']
          },
        },
        {//app计划管理
          path: '/appPlan',
          name: 'appPlan',
          component: AppPlan,
          meta:{
            roles: ['admin', 'dealer']
          },
        },
        {//app下载历史
          path: '/appDownload',
          name: 'appDownload',
          component: AppDownload,
          meta:{
            roles: ['admin', 'dealer']
          },
        },
        {//app设备页面
          path: '/appDevice',
          name: 'appDevice',
          component: AppDevice,
          meta:{
            roles: ['admin', 'dealer']
          },
        },
        {//月度短信
          path: '/SMScost',
          name: 'SMScost',
          component: SMScost,
          meta:{
            roles: ['admin', 'dealer']
          },
        },
        {//充值管理
          path: '/accountRecharge',
          name: 'accountRecharge',
          component: AccountRecharge,
          meta:{
            roles: ['admin', 'dealer']
          },
        },
        {//交易历史
          path: '/accountHistory',
          name: 'accountHistory',
          component: AccountHistory,
          meta:{
            roles: ['admin', 'dealer']
          },
        },
        {//反馈
          path: '/feedBack',
          name: 'feedBack',
          component: FeedBack,
          meta:{
            roles: ['admin', 'dealer']
          },
        },
        {//反馈
          path: '/pushMessage',
          name: 'pushMessage',
          component: Push,
          meta:{
            roles: ['admin', 'dealer']
          },
        },
        {//设置
          path: '/setting',
          name: 'setting',
          component: Setting,
          meta:{
            roles: ['admin', 'dealer']
          },
        },
        {//产品管理
          path: '/productManage',
          name: 'productManage',
          component: ProductManage,
          meta:{
            roles: ['admin', 'dealer','installer']
          },
        },
        {//登录统计
          path: '/loginStatistics',
          name: 'loginStatistics',
          component: LoginStatistics,
          meta:{
            roles: ['admin', 'dealer']
          },
        },
        {//设备管理
          path: '/deviceManage',
          name: 'deviceManage',
          component: DeviceManage,
          meta:{
            roles: ['admin', 'dealer','installer']
          },
        },
        {//设备管理
          path: '/deviceLocation',
          name: 'deviceLocation',
          component: DeviceLocation,
          meta:{
            roles: ['admin', 'dealer','installer']
          },
        },
        {//用户管理
          path: '/userManage',
          name: 'userManage',
          component: UserManage,
          meta:{
            roles: ['admin', 'dealer']
          },
        },
        {//场景模型
          path: '/sceneModel',
          name: 'sceneModel',
          component: SceneModel,
          meta:{
            roles: ['admin', 'dealer']
          },
        },
        {//安装商管理
          path: '/installerManage',
          name: 'installerManage',
          component: InstallerManage,
          meta:{
            roles: ['admin', 'dealer']
          },
        },
        {//app引导页banner
          path: '/onboardingBanner',
          name: 'onboardingBanner',
          component: OnboardingBanner,
          meta:{
            roles: ['admin', 'dealer']
          },
        },
        {//测试页面
          path: '/test',
          name: 'test',
          component: () => import('./views/test/test.vue'),
          meta:{
            roles: ['admin', 'dealer']
          },
        }
      ]
    },
  
  ]

})

//路由前先验证token
router.beforeEach((to, from, next) => {
  window.nowUrlName = to.name;

  let valiToken = common.getToken();

  let roleType = store.state?.uInfo?.roleType
  // let roleType = 3
  // console.log('roleTyperoleType',roleType)

  if(!to.meta.roles.includes('dealer') && roleType==2){//无权限
    next({ path: '/' })
  }

  if(!to.meta.roles.includes('installer') && roleType==3){//无权限
    next({ path: '/' })
  }

  if (to.path == '/login' && valiToken != false) {
    next({ path: '/' })
  }

  if (to.path == '/mng/dealer/findPassword' && valiToken != false) {
    next({ path: '/' })
  }


  if (valiToken == false && to.path != '/login' && to.path != '/mng/dealer/findPassword') {

    localStorage.clear();
    sessionStorage.clear();
    store.commit('setTabMenuList',[{activeId: "0-1",fId: 0,fTitle: "平台首页",name: "平台首页",routeName: "home",routerUrl: "/"}])
    store.commit('setTabMenuItem',{activeId: "0-1",fId: 0,fTitle: "平台首页",name: "平台首页",routeName: "home",routerUrl: "/"})
    document.cookie = "Authorization=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    next({ path: '/login' });
  }




  // let hasRoute = false
  // let hasRouter = false
  // store.state.sideList.map(item=>{
  //   item.children.map(sitem=>{
  //       if('/'+sitem.route==to.path || '/'==to.path){
  //         hasRoute = true
  //       }
  //   })
  // })

  // router.options.routes[6].children.map(item=>{
  //   if(item.path == to.path){
  //     hasRouter = true
  //   }
  // })


  // if(!hasRoute && hasRouter){
  //   next({ path: '/401' });
  // }



  next();

})
export default router